export default __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/shield_mastered-c8ec69ade582ff0662ad0a5d570b4060.png";